import { Injectable, Inject } from '@angular/core';
import { Headers, RequestOptions, Response, ResponseContentType } from '@angular/http';
import { StaticUrls, Sconto, EmailTemplate, Profilo, ImpostazioneEmail, ImpostazioneFtp } from '../models';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { tokenNotExpired, AuthHttp } from 'angular2-jwt';
import { MyCookieService } from './my-cookie.service';
import { DefinizioneServizio } from '../models';
import { environment } from 'environments/environment';

@Injectable()
export class ImpostazioniService {

  private servizi: Array<DefinizioneServizio>;
  private sconti: Array<Sconto>;
  private emailTempllates: Array<EmailTemplate>;
  private profili: Array<Profilo>;
  private impostazioniEmail: Array<ImpostazioneEmail>;
  private impostazioniFtp: Array<ImpostazioneFtp>;
  private headers = new Headers({ 'Content-Type': 'application/json' });
  private options = new RequestOptions({ headers: this.headers });

	constructor(private http: AuthHttp,
		@Inject(MyCookieService) private myCookieService: MyCookieService,
    private router: Router) 
  { }
    
  getDefinizioneServizi(): Observable<Array<DefinizioneServizio>> {
    if(this.myCookieService.token){
      if (this.ifTokenExpired()) {
        return this.http.get(StaticUrls._impostazioniServizi, this.options)
          .map(this.extractDataServizi)
          .catch(this.handleError);
      }
    }
  }

  postDefinizioneServizi(definizioneServizio: DefinizioneServizio): Observable<Response> {
    if(this.myCookieService.token){
      if (this.ifTokenExpired()) {
        return this.http.post(StaticUrls._impostazioniServizi, JSON.stringify(definizioneServizio), this.options)
          .map(response => { return response; })
          .catch(this.handleError);
      }
    }
  }

  getScontiProfilo(): Observable<Array<Sconto>> {
    if(this.myCookieService.token){
      if (this.ifTokenExpired()) {
        return this.http.get(StaticUrls._impostazioniScontiQuery('Profilo'), this.options)
          .map(this.extractDataSconti)
          .catch(this.handleError);
      }
    }
  }

  getScontiUtente(): Observable<Array<Sconto>> {
    if(this.myCookieService.token){
      if (this.ifTokenExpired()) {
        return this.http.get(StaticUrls._impostazioniScontiQuery('Utente'), this.options)
          .map(this.extractDataSconti)
          .catch(this.handleError);
      }
    }
  }

  getScontiUtentePubblicazione(): Observable<Array<Sconto>> {
    if(this.myCookieService.token){
      if (this.ifTokenExpired()) {
        return this.http.get(StaticUrls._impostazioniScontiQuery('Pubblicazione'), this.options)
          .map(this.extractDataSconti)
          .catch(this.handleError);
      }
    }
  }

  getScontiXls() {
		if (this.myCookieService.token) {
			if (this.ifTokenExpired()) {
				const optionsHeaderBlob = new RequestOptions({ responseType: ResponseContentType.Blob, headers: this.headers } );
				return this.http.get(StaticUrls._impostazioniScontiXls, optionsHeaderBlob)
					.map(res => {
						if(res.status === 200){
							return { filename: 'elenco-sconti.xls', data: res.blob() };
						}
					}).catch(this.handleError);
			}
		}
	}

  postScontoProfilo(sconto: Sconto): Observable<Response> {
    if(this.myCookieService.token){
      if (this.ifTokenExpired()) {
        return this.http.post(StaticUrls._impostazioniScontoProfilo, JSON.stringify(sconto), this.options)
          .map(response => { return response; })
          .catch(this.handleError);
      }
    }
  }

  postScontoUtente(sconto: Sconto): Observable<Response> {
    if(this.myCookieService.token){
      if (this.ifTokenExpired()) {
        return this.http.post(StaticUrls._impostazioniScontoUtente, JSON.stringify(sconto), this.options)
          .map(response => { return response; });
      }
    }
  }

  postScontoUtentePubblicazione(sconto: Sconto): Observable<Response> {
    if(this.myCookieService.token){
      if (this.ifTokenExpired()) {
        return this.http.post(StaticUrls._impostazioniScontoPubblicazione, JSON.stringify(sconto), this.options)
          .map(response => { return response; });
      }
    }
  }

  deleteScontoUtente(id: number): Observable<Response> {
    if(this.myCookieService.token){
      if (this.ifTokenExpired()) {
        return this.http.delete(StaticUrls._impostazioniDeleteScontoUtente(id), this.options)
          .map(response => { return response; });
      }
    }
  }

  getEmailTemplate(): Observable<Array<EmailTemplate>> {
    if(this.myCookieService.token){
      if (this.ifTokenExpired()) {
        return this.http.get(StaticUrls._impostazioniEmailTemplates, this.options)
          .map(this.extractDataEmailTemplates)
          .catch(this.handleError);
      }
    }
  }

  postEmailTemplate(emailTemplate: EmailTemplate): Observable<Response> {
    if(this.myCookieService.token){
      if (this.ifTokenExpired()) {
        return this.http.post(StaticUrls._impostazioniEmailTemplates, JSON.stringify(emailTemplate), this.options)
          .map(response => { return response; })
          .catch(this.handleError);
      }
    }
  }

  getImpostazioniEmail(): Observable<Array<ImpostazioneEmail>> {
    if(this.myCookieService.token){
      if (this.ifTokenExpired()) {
        return this.http.get(StaticUrls._impostazioniEmail, this.options)
          .map(this.extractDataImpostazioniEmail)
          .catch(this.handleError);
      }
    }
  }

  postImpostazioniEmail(impostazioniEmail: Array<ImpostazioneEmail>): Observable<Response> {
    if(this.myCookieService.token){
      if (this.ifTokenExpired()) {
        return this.http.post(StaticUrls._impostazioniEmail, JSON.stringify(impostazioniEmail), this.options)
          .map(response => { return response; })
          .catch(this.handleError);
      }
    }
  }

  getImpostazioniFtp(): Observable<Array<ImpostazioneFtp>> {
    if(this.myCookieService.token){
      if (this.ifTokenExpired()) {
        return this.http.get(StaticUrls._impostazioniFtp, this.options)
          .map(this.extractDataImpostazioniFtp)
          .catch(this.handleError);
      }
    }
  }

  postImpostazioniFtp(impostazioniFtp: Array<ImpostazioneFtp>): Observable<Response> {
    if(this.myCookieService.token){
      if (this.ifTokenExpired()) {
        return this.http.post(StaticUrls._impostazioniFtp, JSON.stringify(impostazioniFtp), this.options)
          .map(response => { return response; })
          .catch(this.handleError);
      }
    }
  }

  getProfili(): Observable<Array<Profilo>> {
    if(this.myCookieService.token){
      if (this.ifTokenExpired()) {
        return this.http.get(StaticUrls._impostazioniProfili, this.options)
          .map(this.extractDataProfili)
          .catch(this.handleError);
      }
    }
  }

  inviaMailProva(email: string): Observable<Response> {
    if(this.myCookieService.token){
      if (this.ifTokenExpired()) {
        return this.http.post(StaticUrls._impostazioniTestEmail, email, this.options)
          .map(response => { return response; });
      }
    }
  }

  private extractDataServizi(res: Response) {
    this.servizi = res.json();
    return this.servizi;
  }

  private extractDataSconti(res: Response) {
    this.sconti = res.json();
    return this.sconti;
  }

  private extractDataEmailTemplates(res: Response) {
    this.emailTempllates = res.json();
    return this.emailTempllates;
  }

  private extractDataImpostazioniEmail(res: Response) {
    this.impostazioniEmail = res.json();
    return this.impostazioniEmail;
  }

  private extractDataImpostazioniFtp(res: Response) {
    this.impostazioniFtp = res.json();
    return this.impostazioniFtp;
  }

  private extractDataProfili(res: Response) {
    this.profili = res.json();
    return this.profili;
  }

  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    return Observable.throw(errMsg);
  }

  private ifTokenExpired() {
    if(this.myCookieService.token){
      if (!tokenNotExpired(environment.tokenName)) {
        this.router.navigate(['login']);
        return false;
      } else {
        return true;
      }
    }
  }
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/impostazioni.service.ts